/**
 * ODDFISH — Contact page (FAQ accordion, search, AOS, scroll reveals)
 */
(function () {
  "use strict";

  function initAos() {
    function boot() {
      if (typeof AOS === "undefined") return;

      if (!window.oddfishAosInit) {
        window.oddfishAosInit = true;
        AOS.init({
          once: true,
          duration: 800,
          easing: "ease-out-cubic",
          offset: 120,
          disable: false
        });
      }

      if (typeof AOS.refreshHard === "function") {
        AOS.refreshHard();
      } else if (typeof AOS.refresh === "function") {
        AOS.refresh();
      }
    }

    if (typeof AOS !== "undefined") {
      boot();
    } else {
      window.addEventListener("load", boot, { once: true });
    }
  }

  function initFaqSlideReveal(faqSection) {
    if (faqSection.dataset.oddfishFaqRevealBound) return;
    faqSection.dataset.oddfishFaqRevealBound = "true";

    var items = faqSection.querySelectorAll(".faq_title.slide-left, .item.faq_title.slide-left");
    if (!items.length) return;

    function revealItem(item) {
      if (item.classList.contains("slide-left-visible")) return;
      item.classList.add("slide-left-visible");
    }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            revealItem(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: "0px 0px -5% 0px",
          threshold: 0
        }
      );

      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var viewHeight = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top < viewHeight && rect.bottom > 0) {
          revealItem(item);
        } else {
          observer.observe(item);
        }
      });
    } else {
      items.forEach(revealItem);
    }
  }

  function initFaq(root) {
    var faqSection = root.querySelector(".faq");
    if (!faqSection || faqSection.dataset.oddfishContactFaqBound) return;
    faqSection.dataset.oddfishContactFaqBound = "true";

    faqSection.querySelectorAll(".faq_title, .item.faq_title").forEach(function (title) {
      if (title.dataset.oddfishFaqClickBound) return;
      title.dataset.oddfishFaqClickBound = "true";

      title.addEventListener("click", function () {
        var faqKey = title.getAttribute("data-attr");
        var answer = faqKey ? faqSection.querySelector("." + faqKey) : title.nextElementSibling;
        var isOpen = title.classList.contains("open");

        faqSection.querySelectorAll(".faq_title, .item.faq_title").forEach(function (t) {
          t.classList.remove("open");
          t.setAttribute("aria-expanded", "false");
        });
        faqSection.querySelectorAll(".tab_content, .content").forEach(function (a) {
          a.classList.remove("active");
        });

        if (!isOpen && answer) {
          title.classList.add("open");
          title.setAttribute("aria-expanded", "true");
          answer.classList.add("active");
        }
      });

      title.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          title.click();
        }
      });
    });

    var searchInput = faqSection.querySelector("#oddfish-faq-search");
    if (searchInput && !searchInput.dataset.oddfishSearchBound) {
      searchInput.dataset.oddfishSearchBound = "true";
      searchInput.addEventListener("input", function () {
        var term = searchInput.value.trim().toLowerCase();

        faqSection.querySelectorAll(".faq_title, .item.faq_title").forEach(function (title) {
          var text = title.textContent.trim().toLowerCase();
          var match = !term || text.indexOf(term) > -1;
          title.style.display = match ? "" : "none";

          if (!match) {
            title.classList.remove("open");
            title.setAttribute("aria-expanded", "false");
            var faqKey = title.getAttribute("data-attr");
            var answer = faqKey ? faqSection.querySelector("." + faqKey) : null;
            if (answer) answer.classList.remove("active");
          }
        });
      });
    }

    initFaqSlideReveal(faqSection);
  }

  function initContactForm(root) {
    var form = root.querySelector(".oddfish-contact-page-form");
    if (!form) return;

    var status = root.querySelector(".contact-form-status[data-success='true']");
    if (status) {
      status.scrollIntoView({ behavior: "smooth", block: "center" });
      var successEl = status.querySelector(".form-success");
      if (successEl) successEl.focus();
    }

    if (window.OddfishContactFormsSync && window.OddfishContactFormsSync.bind) {
      window.OddfishContactFormsSync.bind(root, {
        formSelector: ".oddfish-contact-page-form"
      });
    }
  }

  function initFooterCta(root) {
    root.querySelectorAll(".contact_bottom_right .service_link").forEach(function (link) {
      if (link.dataset.oddfishCtaBound) return;
      link.dataset.oddfishCtaBound = "true";

      function showStrike() {
        var btn = link.querySelector(".services_btn");
        if (btn) btn.classList.add("strike-visible");
      }

      function hideStrike() {
        var btn = link.querySelector(".services_btn");
        if (btn) btn.classList.remove("strike-visible");
      }

      link.addEventListener("mouseenter", showStrike);
      link.addEventListener("mouseleave", hideStrike);
      link.addEventListener("focusin", showStrike);
      link.addEventListener("focusout", hideStrike);
    });
  }

  function initMapHeight() {
    document.querySelectorAll(".oddfish-contact-page iframe.map").forEach(function (map) {
      if (window.innerWidth <= 767) {
        map.setAttribute("height", "500px");
      } else {
        map.setAttribute("height", "800px");
      }
    });
  }

  function initSection(root) {
    if (!root || root.dataset.oddfishContactBound) return;
    root.dataset.oddfishContactBound = "true";
    initContactForm(root);
    initFaq(root);
    initFooterCta(root);
  }

  function init() {
    document.querySelectorAll(".oddfish-contact-page").forEach(initSection);
    initAos();
    initMapHeight();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", initAos);
  window.addEventListener("resize", initMapHeight, { passive: true });

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(".oddfish-contact-page");
    if (!section) return;

    delete section.dataset.oddfishContactBound;
    section.querySelectorAll(".oddfish-contact-page-form").forEach(function (contactForm) {
      delete contactForm.dataset.oddfishFormsHandlerBound;
      delete contactForm.dataset.oddfishSubmitting;
    });
    section.querySelectorAll(".faq").forEach(function (faq) {
      delete faq.dataset.oddfishContactFaqBound;
      delete faq.dataset.oddfishFaqRevealBound;
    });

    initSection(section);
    initAos();
  });
})();
